import { useState, type ReactNode } from 'react';

import Sidebar from '../Menu';
import Header from '../Header';
import SecondaryHeader from '../Header/SecondaryHeader';
import SubscriptionNotification from 'components/Subscription';

interface IProps {
  children: ReactNode;
}

const Layout = ({ children }: IProps) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  return (
    <div className="flex h-[100vh] min-h-screen w-full overflow-hidden">
      <aside
        className={`${
          isSidebarOpen ? 'w-64 px-[16px] py-[19px]' : 'w-20 px-[5px] py-[16px]'
        } hidden flex-shrink-0 flex-col justify-between border-r border-r-[#f5f7f9] text-white transition-all duration-300 md:flex`}
      >
        <Sidebar
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
        />
      </aside>

      <div
        className={`flex flex-1 flex-col overflow-auto  w-[calc(100vw-${
          isSidebarOpen ? 256 : 80
        }px)]`}
      >
        <SubscriptionNotification />
        <Header />
        <SecondaryHeader />
        <main className="w-full flex-1 overflow-y-auto transition-all duration-300">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;
